/**
 * Os campos que TODO template entende.
 *
 * Um conjunto so, e nao um por template, de proposito: assim trocar de template
 * nao perde o que a pessoa ja preencheu. O template escolhe quais usa; o
 * formulario mostra todos os que o template escolhido referencia.
 */
export const CAMPOS_TEMPLATE = [
    { chave: 'nome_do_negocio', rotulo: 'Nome do negócio', tipo: 'curto', obrigatorio: true },
    { chave: 'categoria', rotulo: 'Categoria', tipo: 'curto', ajuda: 'Ex.: Arquitetura, Padaria, Clínica' },
    {
        chave: 'chamada',
        rotulo: 'Chamada principal',
        tipo: 'curto',
        ajuda: 'A frase grande logo abaixo do nome',
    },
    { chave: 'sobre', rotulo: 'Sobre o negócio', tipo: 'longo' },
    { chave: 'servico_1_titulo', rotulo: 'Serviço 1 — título', tipo: 'curto' },
    { chave: 'servico_1_texto', rotulo: 'Serviço 1 — descrição', tipo: 'longo' },
    { chave: 'servico_2_titulo', rotulo: 'Serviço 2 — título', tipo: 'curto' },
    { chave: 'servico_2_texto', rotulo: 'Serviço 2 — descrição', tipo: 'longo' },
    { chave: 'servico_3_titulo', rotulo: 'Serviço 3 — título', tipo: 'curto' },
    { chave: 'servico_3_texto', rotulo: 'Serviço 3 — descrição', tipo: 'longo' },
    { chave: 'telefone', rotulo: 'Telefone', tipo: 'telefone' },
    { chave: 'whatsapp', rotulo: 'WhatsApp (só números)', tipo: 'telefone' },
    { chave: 'email', rotulo: 'E-mail', tipo: 'email' },
    { chave: 'endereco', rotulo: 'Endereço', tipo: 'curto' },
    { chave: 'horarios', rotulo: 'Horários', tipo: 'curto', ajuda: 'Um por linha' },
    { chave: 'cta_titulo', rotulo: 'Chamada final', tipo: 'curto' },
    { chave: 'imagem_capa', rotulo: 'Imagem de capa', tipo: 'imagem' },
    { chave: 'imagem_sobre', rotulo: 'Imagem da seção “Sobre”', tipo: 'imagem' },
    { chave: 'galeria_1', rotulo: 'Galeria — imagem 1', tipo: 'imagem' },
    { chave: 'galeria_2', rotulo: 'Galeria — imagem 2', tipo: 'imagem' },
    { chave: 'galeria_3', rotulo: 'Galeria — imagem 3', tipo: 'imagem' },
    { chave: 'galeria_4', rotulo: 'Galeria — imagem 4', tipo: 'imagem' },
    { chave: 'galeria_5', rotulo: 'Galeria — imagem 5', tipo: 'imagem' },
    { chave: 'logo', rotulo: 'Logo (aparece no cabeçalho)', tipo: 'imagem' },
    {
        chave: 'instagram',
        rotulo: 'Instagram',
        tipo: 'curto',
        ajuda: 'Só o @ ou o usuário, sem a URL',
    },
    { chave: 'facebook', rotulo: 'Facebook', tipo: 'curto', ajuda: 'O nome da página' },
    {
        chave: 'depoimento_1_texto',
        rotulo: 'Depoimento 1 — o que disseram',
        tipo: 'longo',
    },
    { chave: 'depoimento_1_autor', rotulo: 'Depoimento 1 — quem disse', tipo: 'curto' },
    { chave: 'depoimento_2_texto', rotulo: 'Depoimento 2 — o que disseram', tipo: 'longo' },
    { chave: 'depoimento_2_autor', rotulo: 'Depoimento 2 — quem disse', tipo: 'curto' },
];
// ---------------------------------------------------------------- helpers ---
const P = (chave) => `{{ ${chave} }}`;
const ZAP = `https://wa.me/${P('whatsapp')}`;
/**
 * O numero como o wa.me exige: so digitos, COM o codigo do pais.
 *
 * Sem o `55` o link nao abre conversa nenhuma — `wa.me/37999990002` e um numero
 * que nao existe para o WhatsApp. Era o que o site publicado tinha no rodape e
 * na secao de contato, e e o unico botao que importa nestes sites.
 *
 * Regra: 10 ou 11 digitos e numero brasileiro sem DDI (fixo ou celular com o 9),
 * e ganha o 55. Qualquer coisa maior ja vem com DDI e passa intacta — inclusive
 * numero de fora do Brasil.
 */
export function numeroWhatsapp(bruto) {
    const d = (bruto ?? '').replace(/\D/g, '');
    if (!d)
        return '';
    return d.length === 10 || d.length === 11 ? `55${d}` : d;
}
/** Os tres cards de servico, iguais em todo template — o que muda e a moldura. */
function servicos(titulo) {
    return {
        tipo: 'servicos',
        titulo,
        itens: [
            { titulo: P('servico_1_titulo'), descricao: P('servico_1_texto') },
            { titulo: P('servico_2_titulo'), descricao: P('servico_2_texto') },
            { titulo: P('servico_3_titulo'), descricao: P('servico_3_texto') },
        ],
    };
}
function galeria(titulo, quantas) {
    return {
        tipo: 'galeria',
        titulo,
        imagens: Array.from({ length: quantas }, (_, k) => ({
            chaveR2: P(`galeria_${k + 1}`),
            alt: P('nome_do_negocio'),
        })),
    };
}
function contato(titulo) {
    return {
        tipo: 'contato',
        titulo,
        telefone: P('telefone'),
        whatsapp: P('whatsapp'),
        endereco: P('endereco'),
        horarios: [P('horarios')],
    };
}
function cta(textoBotao) {
    return {
        tipo: 'cta',
        titulo: P('cta_titulo'),
        subtitulo: '',
        botao: { texto: textoBotao, href: ZAP, estilo: 'primario' },
    };
}
function depoimentos(titulo) {
    return {
        tipo: 'depoimentos',
        titulo,
        itens: [
            { autor: P('depoimento_1_autor'), texto: P('depoimento_1_texto') },
            { autor: P('depoimento_2_autor'), texto: P('depoimento_2_texto') },
        ],
    };
}
// -------------------------------------------------------------- templates ---
/**
 * ============================================================================
 * CINCO TEMPLATES — e por que cinco e nao dez
 * ============================================================================
 *
 * A versao anterior tinha dez. Os dez chamavam `secoesPadrao()`: a MESMA ordem
 * de secao, o MESMO CSS, o MESMO hero. O que mudava era a paleta. Dez sites
 * lado a lado eram reconhecivelmente o mesmo site pintado de outra cor — e o
 * argumento de "nao parecer o site de outros cem clientes" nao se sustentava,
 * porque a forma e o que se reconhece primeiro, nao a cor.
 *
 * Cinco, cada um com LEIAUTE proprio, resolvem melhor o mesmo problema: o
 * renderizador emite estrutura diferente para cada um (secao 'CSS DE CADA
 * LEIAUTE' em `renderizador.ts`), e a ordem e a presenca de secao tambem mudam.
 * Vitrine abre com foto de altura cheia e mosaico; Editorial abre com hero
 * dividido, regras finas e sem galeria; Moderno e escuro com cards de vidro.
 *
 * Todos tem cabecalho com menu e rodape em colunas — que ate aqui nao existiam
 * em template nenhum: o renderizador so emitia secoes soltas e um rodape de uma
 * linha.
 */
export const TEMPLATES = [
    {
        id: 'vitrine-foto',
        nome: 'Vitrine',
        descricao: 'A foto ocupa a tela inteira e a galeria vira mosaico. Para quem vende pelo olho: foto, comida, beleza, festa.',
        palavrasChave: [
            'fotografia', 'fotografo', 'foto', 'restaurante', 'pizzaria', 'hamburgueria',
            'padaria', 'confeitaria', 'doceria', 'cafe', 'bar', 'gastronomia', 'buffet',
            'salao', 'beleza', 'estetica', 'barbearia', 'cabelo', 'unha', 'maquiagem',
            'festa', 'evento', 'decoracao', 'floricultura',
        ],
        paleta: { primaria: '#18181B', secundaria: '#3F3F46', fundo: '#FFFFFF', texto: '#18181B', destaque: '#E11D48' },
        tipografia: { titulo: 'Inter', corpo: 'Inter', escala: 'ampla' },
        leiaute: 'vitrine',
        secoes: [
            {
                tipo: 'hero',
                titulo: P('nome_do_negocio'),
                subtitulo: P('chamada'),
                imagemFundo: { chaveR2: P('imagem_capa'), alt: P('nome_do_negocio') },
                botoes: [{ texto: 'Chamar no WhatsApp', href: ZAP, estilo: 'primario' }],
            },
            galeria('', 5),
            { tipo: 'sobre', titulo: 'Quem somos', texto: P('sobre'), imagem: { chaveR2: P('imagem_sobre'), alt: 'Sobre' } },
            servicos('O que fazemos'),
            depoimentos('Quem já veio'),
            contato('Onde nos achar'),
            cta('Chamar no WhatsApp'),
        ],
    },
    {
        id: 'editorial-serio',
        nome: 'Editorial',
        descricao: 'Serifa, colunas largas e regras finas. Passa seriedade sem parecer datado. Para escritório, clínica e consultoria.',
        palavrasChave: [
            'arquitetura', 'arquiteto', 'engenharia', 'engenheiro', 'urbanismo', 'construtora',
            'advocacia', 'advogado', 'juridico', 'contabilidade', 'contador', 'consultoria',
            'clinica', 'medico', 'odontologia', 'dentista', 'psicologia', 'psicologo',
            'fisioterapia', 'nutricionista', 'veterinaria', 'laboratorio',
        ],
        paleta: { primaria: '#1C1917', secundaria: '#57534E', fundo: '#FAFAF9', texto: '#1C1917', destaque: '#9A3412' },
        tipografia: { titulo: 'Georgia', corpo: 'Georgia', escala: 'ampla' },
        leiaute: 'editorial',
        secoes: [
            {
                tipo: 'hero',
                titulo: P('nome_do_negocio'),
                subtitulo: P('chamada'),
                imagemFundo: { chaveR2: P('imagem_capa'), alt: P('nome_do_negocio') },
                botoes: [{ texto: 'Agendar uma conversa', href: ZAP, estilo: 'primario' }],
            },
            { tipo: 'sobre', titulo: 'Sobre', texto: P('sobre'), imagem: { chaveR2: P('imagem_sobre'), alt: 'Sobre' } },
            servicos('Áreas de atuação'),
            depoimentos('O que dizem'),
            contato('Contato'),
            cta('Agendar uma conversa'),
        ],
    },
    {
        id: 'moderno-escuro',
        nome: 'Moderno',
        descricao: 'Fundo escuro, gradiente e cards de vidro. Para tecnologia, academia, automotivo e agência.',
        palavrasChave: [
            'tecnologia', 'software', 'sistema', 'agencia', 'marketing', 'digital', 'design',
            'academia', 'fitness', 'crossfit', 'personal', 'musculacao', 'pilates',
            'automotivo', 'oficina', 'mecanica', 'funilaria', 'auto', 'carro', 'moto',
            'seguranca', 'energia solar', 'solar', 'startup',
        ],
        paleta: { primaria: '#4F46E5', secundaria: '#7C3AED', fundo: '#0B0B12', texto: '#E4E4E7', destaque: '#22D3EE' },
        tipografia: { titulo: 'Inter', corpo: 'Inter', escala: 'normal' },
        leiaute: 'moderno',
        secoes: [
            {
                tipo: 'hero',
                titulo: P('nome_do_negocio'),
                subtitulo: P('chamada'),
                imagemFundo: { chaveR2: P('imagem_capa'), alt: P('nome_do_negocio') },
                botoes: [{ texto: 'Falar agora', href: ZAP, estilo: 'primario' }],
            },
            servicos('O que entregamos'),
            { tipo: 'sobre', titulo: 'Por que a gente', texto: P('sobre'), imagem: { chaveR2: P('imagem_sobre'), alt: 'Sobre' } },
            galeria('Trabalhos', 3),
            depoimentos('Resultados'),
            contato('Fale com a equipe'),
            cta('Falar agora'),
        ],
    },
    {
        id: 'comercio-direto',
        nome: 'Compacto',
        descricao: 'Uma página densa: muita informação em pouca rolagem. Para comércio e serviço onde o cliente quer o telefone rápido.',
        palavrasChave: [
            'loja', 'comercio', 'mercado', 'mercearia', 'papelaria', 'farmacia', 'pet',
            'petshop', 'material de construcao', 'ferragem', 'autopecas', 'distribuidora',
            'assistencia', 'conserto', 'reforma', 'pintura', 'eletricista', 'encanador',
            'marcenaria', 'serralheria', 'chaveiro', 'dedetizacao', 'limpeza', 'jardinagem',
            'transporte', 'mudanca', 'frete', 'grafica',
        ],
        paleta: { primaria: '#0F766E', secundaria: '#115E59', fundo: '#FFFFFF', texto: '#134E4A', destaque: '#F59E0B' },
        tipografia: { titulo: 'Inter', corpo: 'Inter', escala: 'compacta' },
        leiaute: 'compacto',
        secoes: [
            {
                tipo: 'hero',
                titulo: P('nome_do_negocio'),
                subtitulo: P('chamada'),
                imagemFundo: { chaveR2: P('imagem_capa'), alt: P('nome_do_negocio') },
                botoes: [{ texto: 'Chamar no WhatsApp', href: ZAP, estilo: 'primario' }],
            },
            contato('Atendimento'),
            servicos('O que temos'),
            { tipo: 'sobre', titulo: 'A loja', texto: P('sobre'), imagem: { chaveR2: P('imagem_sobre'), alt: 'Sobre' } },
            galeria('Fotos', 4),
            cta('Chamar no WhatsApp'),
        ],
    },
    {
        id: 'classico-claro',
        nome: 'Clássico',
        descricao: 'Claro, centrado e sem risco. O que serve para qualquer ramo — e o que pega quando nada mais casa.',
        // Vazio de proposito: e o TEMPLATE_PADRAO, o que atende quando nada casa.
        palavrasChave: [],
        paleta: { primaria: '#1D4ED8', secundaria: '#1E40AF', fundo: '#FFFFFF', texto: '#0F172A', destaque: '#2563EB' },
        tipografia: { titulo: 'Inter', corpo: 'Inter', escala: 'normal' },
        leiaute: 'classico',
        secoes: [
            {
                tipo: 'hero',
                titulo: P('nome_do_negocio'),
                subtitulo: P('chamada'),
                imagemFundo: { chaveR2: P('imagem_capa'), alt: P('nome_do_negocio') },
                botoes: [{ texto: 'Falar no WhatsApp', href: ZAP, estilo: 'primario' }],
            },
            { tipo: 'sobre', titulo: 'Sobre', texto: P('sobre'), imagem: { chaveR2: P('imagem_sobre'), alt: 'Sobre' } },
            servicos('Nossos serviços'),
            galeria('Galeria', 3),
            depoimentos('Depoimentos'),
            contato('Contato'),
            cta('Falar no WhatsApp'),
        ],
    },
];
/**
 * ============================================================================
 * O MENU SO APONTA PARA O QUE EXISTE
 * ============================================================================
 *
 * `preencherTemplate` DESCARTA secao sem conteudo: cliente sem depoimento nao
 * ganha a secao de depoimentos. Se o menu fosse fixo no template, ele ficaria
 * com "Depoimentos" apontando para `#depoimentos`, uma ancora que nao existe na
 * pagina — e o link nao faz nada, silenciosamente.
 *
 * Por isso o menu e derivado DEPOIS da filtragem, a partir das secoes que
 * sobraram. Nao ha link morto porque nao ha como haver.
 */
const ROTULO_SECAO = {
    sobre: 'Sobre',
    servicos: 'Serviços',
    galeria: 'Galeria',
    depoimentos: 'Depoimentos',
    contato: 'Contato',
};
function menuDasSecoes(secoes) {
    const vistos = new Set();
    const itens = [];
    for (const s of secoes) {
        const rotulo = ROTULO_SECAO[s.tipo];
        // Uma ancora por tipo: duas secoes 'galeria' nao viram dois "Galeria".
        if (!rotulo || vistos.has(s.tipo))
            continue;
        vistos.add(s.tipo);
        itens.push({ texto: rotulo, href: `#${s.tipo}` });
    }
    return itens;
}
/** Perfil de rede social a partir do que a pessoa digitou (@nome ou URL). */
function urlDaRede(base, valor) {
    const v = valor.trim();
    if (!v)
        return null;
    if (/^https?:\/\//i.test(v))
        return v;
    return `${base}${v.replace(/^@/, '')}`;
}
/** Busca por id. `undefined` quando o id nao existe — quem chama decide o padrao. */
export function templatePorId(id) {
    return TEMPLATES.find((t) => t.id === id);
}
/** O de ultimo recurso, quando nada casa. Existe sempre. */
export const TEMPLATE_PADRAO = TEMPLATES.find((t) => t.palavrasChave.length === 0) ?? TEMPLATES[TEMPLATES.length - 1];
/**
 * Escolhe um template a partir da categoria e do nome do negocio.
 *
 * Deterministica de proposito: o mesmo cliente sempre cai no mesmo template.
 * Sem isso, reprocessar um job trocaria o visual do site sem ninguem pedir — e
 * `content_hash` deixaria de evitar republicacao.
 */
export function escolherTemplate(categoria, nome) {
    const alvo = `${categoria ?? ''} ${nome ?? ''}`
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase();
    for (const t of TEMPLATES) {
        if (t.palavrasChave.some((p) => alvo.includes(p)))
            return t;
    }
    return TEMPLATE_PADRAO;
}
/**
 * ============================================================================
 * O SORTEIO — aleatorio para quem olha, estavel para a maquina
 * ============================================================================
 *
 * O pedido foi "escolher aleatoriamente entre os cinco". O objetivo por tras
 * disso e claro: cem clientes importados juntos nao podem sair todos com a
 * mesma cara.
 *
 * `Math.random()` resolveria a aparencia e quebraria duas coisas de verdade:
 *
 *   1. **Reprocessar um job trocaria o site.** A fila reprocessa por desenho —
 *      lease vencido, worker reiniciado, retentativa. Com sorteio ao vivo, o
 *      mesmo `gerar_site` publicaria um template hoje e outro amanha, sem
 *      ninguem ter pedido.
 *   2. **`content_hash` pararia de servir.** Ele existe para nao reescrever no
 *      R2 o que nao mudou. Se cada render sorteia de novo, todo render difere,
 *      e toda republicacao reescreve — em 100 mil sites isso e o egress
 *      faturado do diagnostico.
 *
 * Entao o sorteio e SEMEADO pelo id do cliente: espalha entre os cinco como um
 * sorteio espalha, e o mesmo cliente cai sempre no mesmo. FNV-1a de 32 bits —
 * nao e criptografia, e distribuicao, e para isso ele basta e cabe em tres
 * linhas que rodam igual no Node, no Bun e no Worker da borda.
 */
export function sortearTemplate(semente) {
    let h = 0x811c9dc5;
    for (let i = 0; i < semente.length; i++) {
        h ^= semente.charCodeAt(i);
        // `Math.imul` mantem a multiplicacao em 32 bits; sem ele o numero estoura
        // para double e o hash deixa de ser o FNV-1a em maquina nenhuma.
        h = Math.imul(h, 0x01000193);
    }
    return TEMPLATES[Math.abs(h) % TEMPLATES.length];
}
/**
 * O template para o FALLBACK: sorteado, mas respeitando a categoria quando ela
 * diz algo.
 *
 * Categoria casada e informacao de verdade — uma pizzaria fica melhor na
 * Vitrine que num sorteio. Quando nada casa, em vez de mandar todo mundo para o
 * mesmo `TEMPLATE_PADRAO`, sorteia. E essa a diferenca que a esteira mostra:
 * antes, todo cliente sem categoria reconhecida saia identico.
 */
export function templateDeFallback(semente, categoria, nome) {
    const porCategoria = escolherTemplate(categoria, nome);
    if (porCategoria.palavrasChave.length > 0)
        return porCategoria;
    return sortearTemplate(semente);
}
/** Quais `{{ campos }}` este template realmente usa. Ordem estavel. */
export function camposDoTemplate(t) {
    const texto = JSON.stringify(t.secoes);
    return CAMPOS_TEMPLATE.filter((c) => texto.includes(`{{ ${c.chave} }}`));
}
// ------------------------------------------------------------ preenchimento ---
const RE_PLACEHOLDER = /\{\{\s*([a-z0-9_]+)\s*\}\}/gi;
/** Troca `{{ campo }}` pelo valor. Campo sem valor vira string vazia. */
function trocar(texto, valores) {
    return texto.replace(RE_PLACEHOLDER, (_, chave) => valores[chave] ?? '');
}
/** Ainda restou algum `{{ }}` sem valor neste texto? */
function temPlaceholderVazio(texto, valores) {
    RE_PLACEHOLDER.lastIndex = 0;
    for (const m of texto.matchAll(RE_PLACEHOLDER)) {
        const chave = m[1];
        if (!chave)
            continue;
        if (!valores[chave])
            return true;
    }
    return false;
}
/**
 * Aplica os valores ao template e devolve um `SiteSpec` pronto para publicar.
 *
 * A regra que importa: **conteudo sem valor SOME, em vez de sair vazio**. Um
 * card de servico com titulo em branco, uma galeria com tres imagens que nao
 * existem e um `{{ telefone }}` literal no rodape sao piores que a ausencia da
 * secao — e sao exatamente o que um `replace` ingenuo produz.
 */
export function preencherTemplate(template, valoresBrutos) {
    // Normaliza o WhatsApp UMA vez, na entrada. `valoresDoCliente` ja entrega
    // certo, mas o formulario do painel entrega o que a pessoa digitou — e o link
    // sem DDI nao abre conversa nenhuma.
    const valores = {
        ...valoresBrutos,
        whatsapp: numeroWhatsapp(valoresBrutos.whatsapp ?? ''),
    };
    const v = (chave) => valores[chave]?.trim() ?? '';
    const nome = v('nome_do_negocio') || 'Meu negócio';
    const categoria = v('categoria');
    const secoes = [];
    for (const bruta of template.secoes) {
        const s = JSON.parse(JSON.stringify(bruta));
        switch (s.tipo) {
            case 'hero': {
                s.titulo = trocar(s.titulo, valores) || nome;
                s.subtitulo = trocar(s.subtitulo, valores);
                // Imagem sem chave real nao vira `<img src="">`: some.
                s.imagemFundo = v('imagem_capa')
                    ? { chaveR2: v('imagem_capa'), alt: nome }
                    : undefined;
                s.botoes = v('whatsapp')
                    ? s.botoes.map((b) => ({ ...b, href: trocar(b.href, valores) }))
                    : [];
                break;
            }
            case 'sobre': {
                // Sem texto nao ha secao "Sobre" — um titulo sozinho nao informa nada.
                if (!v('sobre'))
                    continue;
                s.texto = trocar(s.texto, valores);
                s.imagem = v('imagem_sobre') ? { chaveR2: v('imagem_sobre'), alt: s.titulo } : undefined;
                break;
            }
            case 'servicos': {
                s.itens = s.itens
                    .map((i) => ({
                    ...i,
                    titulo: trocar(i.titulo, valores),
                    descricao: trocar(i.descricao, valores),
                }))
                    // Card sem titulo e um retangulo vazio na tela.
                    .filter((i) => i.titulo.trim().length > 0);
                if (s.itens.length === 0)
                    continue;
                break;
            }
            case 'galeria': {
                s.imagens = s.imagens
                    .map((img) => ({ ...img, chaveR2: trocar(img.chaveR2, valores), alt: nome }))
                    .filter((img) => img.chaveR2.trim().length > 0);
                if (s.imagens.length === 0)
                    continue;
                break;
            }
            case 'contato': {
                s.telefone = v('telefone') || undefined;
                s.whatsapp = v('whatsapp') || undefined;
                s.email = v('email') || undefined;
                s.endereco = v('endereco') || undefined;
                s.horarios = v('horarios')
                    ? v('horarios').split('\n').map((l) => l.trim()).filter(Boolean)
                    : [];
                // Secao de contato sem nenhum contato e so um titulo.
                if (!s.telefone && !s.whatsapp && !s.email && !s.endereco)
                    continue;
                break;
            }
            case 'cta': {
                if (!v('whatsapp') && !v('telefone'))
                    continue;
                s.titulo = trocar(s.titulo, valores) || `Fale com ${nome}`;
                s.subtitulo = trocar(s.subtitulo, valores);
                s.botao = { ...s.botao, href: trocar(s.botao.href, valores) };
                break;
            }
            case 'depoimentos': {
                s.itens = s.itens.map((i) => ({
                    ...i,
                    autor: trocar(i.autor, valores),
                    texto: trocar(i.texto, valores),
                }));
                if (s.itens.length === 0)
                    continue;
                break;
            }
            case 'htmlBruto': {
                s.html = trocar(s.html, valores);
                break;
            }
        }
        // Rede final: se sobrou algum `{{ }}` sem valor em qualquer campo desta
        // secao, e porque o caso nao foi tratado acima. Melhor perder a secao do que
        // publicar a chave crua para o visitante ler.
        if (temPlaceholderVazio(JSON.stringify(s), valores))
            continue;
        secoes.push(s);
    }
    const menu = menuDasSecoes(secoes);
    const logo = v('logo') ? { chaveR2: v('logo'), alt: nome } : undefined;
    const cabecalho = {
        marca: nome,
        logo,
        menu,
        // Sem WhatsApp nao ha botao: um "Fale conosco" que nao abre nada e pior
        // que nenhum botao.
        acao: v('whatsapp')
            ? { texto: 'WhatsApp', href: `https://wa.me/${v('whatsapp')}`, estilo: 'primario' }
            : undefined,
        fixo: true,
    };
    const redes = [];
    const ig = urlDaRede('https://instagram.com/', v('instagram'));
    if (ig)
        redes.push({ rede: 'instagram', href: ig });
    const fb = urlDaRede('https://facebook.com/', v('facebook'));
    if (fb)
        redes.push({ rede: 'facebook', href: fb });
    if (v('whatsapp'))
        redes.push({ rede: 'whatsapp', href: `https://wa.me/${v('whatsapp')}` });
    const rodape = {
        // Uma linha, nao o texto inteiro do "Sobre": a coluna do rodape nao e lugar
        // de paragrafo.
        sobre: v('sobre').split(/(?<=\.)\s/)[0]?.slice(0, 180) ?? '',
        menu,
        redes,
        // Sem ano. `new Date()` tornaria o render nao deterministico e viraria o
        // hash de todo site publicado na virada do ano.
        assinatura: `\u00a9 ${nome}`,
    };
    return {
        versaoSpec: 1,
        template: template.id,
        negocio: {
            nome,
            categoria,
            telefone: v('telefone'),
            whatsapp: v('whatsapp'),
            endereco: v('endereco'),
            logo,
        },
        paleta: template.paleta,
        leiaute: template.leiaute,
        cabecalho,
        rodape,
        tipografia: template.tipografia,
        seo: {
            titulo: categoria ? `${nome} — ${categoria}` : nome,
            descricao: v('sobre').slice(0, 160) || `${categoria || 'Atendimento'}. Fale conosco.`,
            palavrasChave: [],
            indexavel: true,
        },
        secoes,
        cssExtra: '',
    };
}
/**
 * Pre-preenche os campos com o que JA SE SABE do cliente.
 *
 * E o ponto do formulario nao comecar vazio: os dados de negocio ja estao no
 * banco (nome, telefone, endereco, categoria, resumo, palavras-chave). Fazer o
 * operador redigitar o que a captacao ja coletou e o tipo de trabalho que faz a
 * esteira nao ser usada.
 */
export function valoresDoCliente(cliente) {
    const n = cliente.dadosNegocio;
    const categoria = cliente.categoria ?? n?.categorias?.[0] ?? '';
    const telefone = cliente.telefone ?? '';
    const chaves = n?.palavrasChaveSeo ?? [];
    return {
        nome_do_negocio: cliente.nome,
        categoria,
        chamada: categoria ? `${categoria} em que você pode confiar.` : 'Atendimento de confiança.',
        sobre: n?.resumo ?? '',
        // As tres primeiras palavras-chave viram os tres servicos. Nao e adivinhacao:
        // sao os termos que a propria captacao extraiu do negocio.
        servico_1_titulo: chaves[0] ?? '',
        servico_1_texto: chaves[0] ? `${chaves[0]} com atendimento próximo e prazo combinado.` : '',
        servico_2_titulo: chaves[1] ?? '',
        servico_2_texto: chaves[1] ? `${chaves[1]} sob medida para o que você precisa.` : '',
        servico_3_titulo: chaves[2] ?? '',
        servico_3_texto: chaves[2] ? `${chaves[2]} do orçamento à entrega.` : '',
        telefone,
        // Com DDI: e o que o wa.me precisa, e o que o spec passa a guardar.
        whatsapp: numeroWhatsapp(telefone),
        email: cliente.email ?? '',
        endereco: cliente.endereco ?? '',
        horarios: Array.isArray(n?.horarios) ? n.horarios.join('\n') : '',
        cta_titulo: `Fale com ${cliente.nome}`,
        imagem_capa: '',
        imagem_sobre: '',
        galeria_1: '',
        galeria_2: '',
        galeria_3: '',
    };
}
//# sourceMappingURL=templates.js.map